import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';
import { MASTER_STATUSES } from '../services/api';
import { Lock } from 'lucide-react';

// Phone layout of a masters table: one card per master, status always visible.
// The name link is stretched over the whole card; the actions menu sits above it.
export const MasterCards = ({ masters, statusClass, renderActions, projectTitle }) => (
    <ul className="sm:hidden space-y-2" aria-label="Masters">
        {masters.map((master) => (
            <li
                key={master.id}
                className="relative p-3 rounded-lg border border-border bg-card hover:border-primary/30 transition-colors focus-within:ring-1 focus-within:ring-ring"
                data-testid={`master-card-${master.id}`}
            >
                <div className="flex items-start gap-2">
                    <div className="flex-1 min-w-0">
                        <Link
                            to={`/masters/${master.id}`}
                            className="font-mono text-sm break-all after:absolute after:inset-0 after:content-[''] focus-visible:outline-none"
                        >
                            {master.name}
                        </Link>
                        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
                            <Badge variant="outline" className={`text-xs ${statusClass(master.status)}`}>
                                {MASTER_STATUSES[master.status] || master.status}
                            </Badge>
                            {master.encrypted && (
                                <span className="inline-flex items-center gap-1 text-tone-ecrase">
                                    <Lock className="w-3 h-3" aria-hidden="true" />
                                    Crypté
                                </span>
                            )}
                            <span className="font-mono">{master.disk_number}</span>
                            <span className="font-mono">{master.duration_tc}</span>
                            <span>{master.format}</span>
                            {projectTitle && <span className="truncate max-w-full">{projectTitle(master.project_id)}</span>}
                        </div>
                    </div>
                    {renderActions && <div className="relative z-10 -mr-1 -mt-1">{renderActions(master)}</div>}
                </div>
            </li>
        ))}
    </ul>
);
